/**
 * Application version in semver format (MAJOR.MINOR.PATCH)
 *
 * MAJOR: Major version for significant changes
 * MINOR: Minor version for new features
 * PATCH: Patch version, auto-incremented during build process
 *
 * This file is processed during the build to auto-increment the PATCH version.
 */


export const version = `2.0.7-dev.82`;
export const buildTimestamp = '2026-09-04T17:25:11Z';

// FUNCTION EXPORTS

/**
 * Returns a URL with a version query parameter to prevent caching
 * @param {string} url - The URL to append the version to
 * @returns {string} - URL with version query parameter
 */
export function getVersionedUrl(url) {
    const separator = url.includes('?') ? '&' : '?';
    const result = `${url}${separator}v=${version}`;
    console.log(`Versioning URL: ${url} -> ${result}`);
    return result;
}

/**
 * Applies version query parameter to all URLs in an object
 * @param {Object} obj - Object containing URLs
 * @returns {Object} - Object with versioned URLs
 */
export function versionUrls(obj) {
    const result = {...obj};

    for (const key in result) {
        if (typeof result[key] === 'string' && (
            result[key].startsWith('/') ||
            result[key].startsWith('./') ||
            result[key].startsWith('http')
        )) {
            result[key] = getVersionedUrl(result[key]);
        } else if (typeof result[key] === 'object' && result[key] !== null) {
            result[key] = versionUrls(result[key]);
        }
    }

    return result;
}